import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';

import externalConfiguration from '../external-configuration';

import defaultProps from './default-props';
import propTypes from './prop-types';
import './chat-sidebar.css';

import { avoidCache, hashCode, isIE11, IE11_safeIncludes } from '../helpers/utils';

const displayName = 'ChatSidebar';

class ChatSidebar extends Component {
  constructor(props) {
    super(props);
    this.API_BASE_URI = `${externalConfiguration.chatBackEndDomain}${externalConfiguration.chatRootPath}`;
    this.fetchHandler = this.fetchHandler.bind( this);
    this.customFetch = this.customFetch.bind( this);
    this.loadMessages = this.loadMessages.bind( this);
    this.publishMessage = this.publishMessage.bind( this);
    this.onKeyDown = this.onKeyDown.bind( this);
    this.login = this.login.bind( this);
    this.logout = this.logout.bind( this);
    this.register = this.register.bind( this);
    this.resendActivationToken = this.resendActivationToken.bind( this);
    this.resetPassword = this.resetPassword.bind( this);
    this.changePassword = this.changePassword.bind( this);
    this.socialLogin = this.socialLogin.bind( this);
    this.styleMessage = this.styleMessage.bind( this);
    this.setForm = this.setForm.bind( this);
    this.googleClientId = this.googleClientId.bind( this);
    let renderForm = null;
    let login = false;
    let sessionToken = '';
    if( 'sessionToken' in props.queryParams) {
      renderForm = 'changePassword';    // 'login', 'register', 'userName', 'changePassword'
      login = true;
      sessionToken = props.queryParams.sessionToken;
    }
    this.state = {
      messagesList: [],
      renderForm,
      login,
      sessionToken,
      showDate: props.visualizerOptions.srcType === 'vod',
      showTime: true,
      showOptions: false,
      showHide: true,
    }
    this.renderFormBar = [ 'login', 'register'];
    this.inputField = { value: ''};
    this.mustFocus = true;
    this.lastMessage = null;
    this.mustScroll = true;
    this.mustSetUserName = !props.chatSettings.hasRegister;
    this.userName = '';
    this.userNameField = { value: ''};
    this.inputs = {};
    this.waitingPublish = false;
  }
  componentWillMount() {
    this.loadMessages();
    this.refreshInterval = setInterval( () => {
      this.loadMessages();
    }, externalConfiguration.chatSettings.refreshInterval);
  }
  setForm( renderForm) {
    this.mustFocus = true;
    this.setState({ renderForm});
  }
  fetchHandler( uri, options = {}) {
    uri = avoidCache( uri);
    if( 'uri' in options) options.uri = uri;
    if( this.state.sessionToken) {
      if( !options.headers) options.headers = {};
      if( !options.headers['x-access-token']) options.headers['x-access-token'] = this.state.sessionToken;
    }
    return fetch( uri, options)
      .then( response => {
        if( !response.ok) throw response;
        return response.json();
      }).catch( baseError => {
        if( baseError.json) baseError.json()
          .then( errorResponse => {
            if( errorResponse.msg) alert( errorResponse.msg);
            console.error( errorResponse);
          }).catch( error => {
            console.error( error);
          });
        return { 'Error Code': true };
      });
  }
  loadMessages() {
    return this.fetchHandler( `${this.API_BASE_URI}message/filter/${this.props.chatSettings.iframeId}`)
      .then( messagesList => this.setState( { messagesList}));
  }
  customFetch( route, data, method = 'POST') {
    const uri = `${this.API_BASE_URI}${route}`;
    const headers = {
      'Content-Type': 'application/json',
    };
    const options = {
      method,
      headers,
      uri,
      body: JSON.stringify( data),
    };
    return this.fetchHandler( uri, options);
  }
  publishMessage() {
    if( this.mustSetUserName) {
      this.mustFocus = true;
      this.setForm( 'userName');
    } else if( !this.waitingPublish){
      if( this.props.hasRegister && !this.state.login) {
        alert( 'Publicar mensajes requiere estar logueado');
      } else {
        this.waitingPublish = true;
        this.customFetch( 'message/' + this.props.chatSettings.iframeId, {
          sessionToken: this.state.sessionToken,
          text: this.inputField.value,
          userName: this.userName,
        }).then( response => {
          if( 'Error Code' in response) this.mustSetUserName = !this.props.chatSettings.hasRegister;
          this.mustScroll = true;
          this.waitingPublish = false;
          return this.loadMessages();
        }).then( () => this.inputField.value = '');
      }
    }
  }
  onKeyDown(e) {
    if( e.key === 'Enter'){
      this.publishMessage()
    }
  }
  login( inputs) {
    this.customFetch( `userchat/login/${this.props.chatSettings.iframeId}`, { mail: inputs.mail.value, password: inputs.password.value})
    .then( response => {
      if( !('Error Code' in response)) {
        this.setState( { renderForm: null, login: true, sessionToken: response.sessionToken});
      }
    });
  }
  logout() {
    this.setState( { login: false});
  }
  register( inputs) {
    if( inputs.password.value !== inputs.password2.value) {
      alert( 'Los campos de password no coinciden, reviselos.');
    } else if( inputs.mail.value !== inputs.mail2.value) {
      alert( 'Los campos de mail no coinciden, reviselos.');
    } else {
      this.customFetch( `userchat/${this.props.chatSettings.iframeId}`, {
        name: inputs.name.value,
        userName: inputs.userName.value,
        password: inputs.password.value,
        mail: inputs.mail.value,
      }).then( response => {
        if( response.msg) alert( response.msg);
        this.setState( { renderForm: null});
      });
    }
  }
  resendActivationToken( inputs) {
    this.customFetch( `userchat/activate/${this.props.chatSettings.iframeId}`, {
      mail: inputs.mail.value,
    }).then( response => {
      if( response.msg) alert( response.msg);
    });
  }
  resetPassword( inputs) {
    this.customFetch( `userchat/password/${this.props.chatSettings.iframeId}`, {
      mail: inputs.mail.value,
      location: `${window.location}`,
    }).then( response => {
      if( response.msg) alert( response.msg);
    });
  }
  changePassword( inputs) {
    if( inputs.password.value !== inputs.password2.value) {
      alert( 'Los campos de password no coinciden, reviselos.');
    }
    this.customFetch( `userchat/password/${this.props.chatSettings.iframeId}`, {
      sessionToken: this.state.sessionToken,
      password: inputs.password.value,
    }, 'PUT').then( response => {
      if( response.msg) alert( response.msg);
      this.setState( { renderForm: null});
    });
  }
  socialLogin( response, socialNetwork = 'unknown') {
    let userName, socialId, mail;
    if( 'name' in response) userName = response.name;               // facebook
    if( 'id' in response) socialId = response.id;                   // facebook
    if( 'email' in response) mail = response.email;                 // facebook
    if( 'El' in response) socialId = response.El;                   // google
    if( 'googleId' in response) socialId = response.googleId;       // google
    if( 'profileObject' in response) {                              // google
      if( 'name' in response.profileObject) userName = response.profileObject.name;
      if( 'googleId' in response.profileObject) socialId = response.profileObject.googleId;
      if( 'email' in response.profileObject) mail = response.profileObject.email;
    }
    if( 'profileObj' in response) {                                 // google
      if( 'name' in response.profileObj) userName = response.profileObj.name;
      if( 'googleId' in response.profileObj) socialId = response.profileObj.googleId;
      if( 'email' in response.profileObj) mail = response.profileObj.email;
    }
    this.customFetch( `userchat/socialLogin/${this.props.chatSettings.iframeId}`, { userName, socialId, mail, socialNetwork})
    .then( response => {
      if( !('Error Code' in response)) {
        this.setState( { renderForm: null, login: true, sessionToken: response.sessionToken});
      }
    });
  }
  googleClientId() {
    switch( window.location.host) {
      case 'vdmplayer.codev8.net':
        return externalConfiguration.chatSettings.googleVdmplayerId;
      case 'democdnplayer.codev8.net':
        return externalConfiguration.chatSettings.googleDemocdnplayerId;
      case 'cdnapi.codev8.net':
        return externalConfiguration.chatSettings.googleCdnapiId;
    }
  }
  renderSocialLogin() {
    const googleClientId = this.googleClientId();
    return (
      <div className={'row'}>
        <label>SOCIAL LOGIN</label>
        <FacebookLogin
          //className={'btn-social-media'}
          appId={ externalConfiguration.chatSettings.facebookAppId }
          fields='name,email'
          // autoLoad={true}
          // onClick={componentClicked}
          cssClass={'btn-social-media btn-facebook'}
          // size='small'
          icon='fa-facebook-square'
          textButton=''
          callback={ response => this.socialLogin( response, 'facebook') }
        />
        <GoogleLogin
          clientId={ googleClientId }
          buttonText=''
          className={'google-button fa fa-google-plus-square btn-margin btn-social-media'}
          onSuccess={ response => this.socialLogin( response, 'google+') }
          //  onFailure={responseGoogle}
          disabled={ !googleClientId }
        />
        <button className={'cancel pull-right'} onClick={ () => this.setState( { renderForm: null}) }> X </button>
      </div>
    );
  }
  renderInputsForm() {
    const functions = { login: this.login, register: this.register, changePassword: this.changePassword};
    const send = inputs => functions[ this.state.renderForm](inputs);
    const enterHandler = e => ( e.key === 'Enter' ? send( this.inputs) : null);
    switch( this.state.renderForm) {
      case 'login':
        return (
          <div className={'padding-input'}>
            <label> Email: </label>
            <input className={'form-control'} ref={ ref => this.inputs.mail = ref} onKeyDown={enterHandler}></input>
            <label> Password: </label>
            <input className={'form-control'} ref={ ref => this.inputs.password = ref} type='password' onKeyDown={enterHandler}></input>
            <button className={'cancel password'} onClick={ () => this.resendActivationToken( this.inputs)}>Resend activation token</button><br/>
            <button className={'cancel password'} onClick={ () => this.resetPassword( this.inputs)}>Don't you remember your password? Click here</button>
            <hr />
            <div className={'btn-group pull-right'}>
              <button className={'cancel'} onClick={ () => this.setState( { renderForm: null}) }> Cancel </button>
              <button className={'submit'} onClick={ () => send( this.inputs) }> Log in </button>
            </div>
          </div>
        );
      case 'register':
        return (
          <div className={'padding-input'}>
            <div className={'column'}>
              <label> Name: </label>
              <input className={'form-control'} ref={ ref => this.inputs.name = ref} onKeyDown={enterHandler}></input>
            </div>
            <div className={'column'}>
              <label> Username: </label>
              <input className={'form-control'} ref={ ref => this.inputs.userName = ref} onKeyDown={enterHandler}></input>
            </div>
            <div className={'column'}>
              <label> Mail: </label>
              <input className={'form-control'} ref={ ref => this.inputs.mail = ref} onKeyDown={enterHandler}></input>
            </div>
            <div className={'column'}>
              <label> Repeat mail: </label>
              <input className={'form-control'} ref={ ref => this.inputs.mail2 = ref} onKeyDown={enterHandler}></input>
            </div>
            <div className={'column'}>
              <label> Password: </label>
              <input className={'form-control'} ref={ ref => this.inputs.password = ref} type='password' onKeyDown={enterHandler}></input>
            </div>
            <div className={'column'}>
              <label> Repeat password: </label>
              <input className={'form-control'} ref={ ref => this.inputs.password2 = ref} type='password' onKeyDown={enterHandler}></input>
            </div>
            <div className={'btn-group pull-right'}>
              <br />
              <button className={'cancel'} onClick={ () => this.setState( { renderForm: null}) }> Cancel </button>
              <button className={'submit'} onClick={ () => send( this.inputs) }> Sing Up </button>
            </div>
          </div>
        );
      case 'userName':
        const submit = () => {
          this.mustSetUserName = false;
          this.userName = this.userNameField.value;
          this.publishMessage();
          this.setState({ renderForm: null});
        };
        const onKeyDown = e => {
          if( e.key === 'Enter') submit();
        };
        return (
          <div className={'form username'}>
            <label> UserName: </label>
            <input className={'form-control'} ref={ ref => this.userNameField = ref} onKeyDown={onKeyDown}/>
            <button className={'submit pull-right'} onClick={ submit } > Submit </button>
          </div>
        );
      case 'changePassword':
        return (
          <div className={''}>
            <div className={'tab'}>
              <label>CHANGE PASSWORD</label>
            </div>
            <br />
            <label> New password: </label>
            <input className={'form-control'} ref={ ref => this.inputs.password = ref} type='password' onKeyDown={enterHandler}></input>
            <label> Repeat password: </label>
            <input className={'form-control'} ref={ ref => this.inputs.password2 = ref} type='password' onKeyDown={enterHandler}></input>
            <div className={'btn-group pull-right'}>
              <br />
              <button className={'cancel'} onClick={ () => this.setState( { renderForm: null}) }> Cancel </button>
              <button className={'submit'} onClick={ () => send( this.inputs) }> Send </button>
            </div>
          </div>
        );
      default:;
    }
    return '';
  }
  renderForm() {
    return (
      <div className={'form ' + this.state.renderForm}>
        { IE11_safeIncludes( this.renderFormBar, this.state.renderForm) ? (
          <div>
            { this.renderSocialLogin() }
            <hr />
            <div className={'tab'}>
              <button
                className={(this.state.renderForm === 'login') ? 'tab-active' : ''}
                onClick={ () => this.setForm( 'login') }
              >Log In</button>
              <button
                className={(this.state.renderForm === 'register') ? 'tab-active' : ''}
                onClick={ () => this.setForm('register') }
              >Sign Up</button>
            </div>
            <br />
          </div>
        ) : '' }
        { this.renderInputsForm() }
      </div>
    );
  }
  styleMessage( message) {
    const colors = [ 'red', 'blue', 'green', 'brown', 'fuchsia', 'black', 'orange'];
    const userId = message.userId ? message.userId : hashCode( message.userName);
    if( !this.baseColor) this.baseColor = Math.floor( Math.random() * colors.length);
    return { color: colors[ ( userId + this.baseColor ) % colors.length]};
  }
  render() {
    if( !this.props.chatSettings.showingChat) return <div/>;
    const dateOptions = { year: 'numeric', month: '2-digit', day: 'numeric' };
    const hourOptions = { hour: '2-digit', minute: '2-digit'};
    this.props.chatSettings.chatStyle = ''; //'light';    // TODO: parametrizar el estilo.

    const showDate = () => this.setState({ showDate: !this.state.showDate })
    const showTime = () => this.setState({ showTime: !this.state.showTime })
    const showOptions = event => {
      this.setState({ showOptions: !this.state.showOptions, pageX: event.pageX, pageY: event.pageY });
    }
    const BuildAnonymousUserName = message => {
      let userName = message.userName;
      let className = '';
      if( !userName || userName === '') {
        userName = '"Anonymous"';
        className = 'anonymous';
      }
      return <b className={ className }>{ userName }</b>;
    };
    return (
      <div className={'sidebar ' + this.props.chatSettings.chatStyle} style={{ width: window.innerWidth - this.props.customProps.width, height: this.props.customProps.height}}>
        <div className={'title-box ' + (this.props.chatSettings.hasRegister ? 'has-register' : '')}>
          <div className={(this.props.chatSettings.hasRegister) ? 'column-4' : ''}>
            <h5>Chat del Directo</h5>
          </div>
          { this.props.chatSettings.hasRegister ?
            <div className={'column-8'}>
              <div className="btn-group pull-right">
                { this.state.login ? <div>
                  <button className={'btn-chat'} onClick={ () => this.setForm( 'changePassword') }> Change password </button>
                  <button className={'btn-chat btn-margin'} onClick={ this.logout }> Logout </button>
                </div> : <div>
                  <button className={'btn-chat'} onClick={ () => this.setForm( 'register') }> Sign Up </button>
                  <button className={'btn-chat btn-margin'} onClick={ () => this.setForm( 'login') }> Log In </button>
                </div> }
              </div>
            </div>
          : '' }
          <hr />
        </div>
        <div className={'message-box ' + (this.props.chatSettings.hasRegister ? 'has-register' : '')}>
          { this.state.messagesList.map( ( message, i) => {
            return (
              <div key={i} className={'message'} ref={ ref => { let a = ReactDOM.findDOMNode(ref); if(a) this.lastMessage = a; }}>
                { this.state.showDate ?
                  <span className={'date'}><i>{ new Date( message.date).toLocaleDateString( 'es-ES', dateOptions) } </i></span>
                : ''}
                { this.state.showTime ?
                  <span className={'date'}>{ new Date( message.date).toLocaleTimeString( 'es-ES', hourOptions) } </span>
                : ''}
                <span style={ this.styleMessage( message) }>{ BuildAnonymousUserName( message ) } :</span>
                { message.deleted ? <span><i> This message was deleted.</i></span> : <span> { message.text }</span> }
              </div>
            );
          })}
        </div>
        <div className={'input-box'}>
          <textarea className={'form-control input-message'} onKeyDown={ this.onKeyDown } ref={ ref => this.inputField = ref} />
          <div className="column-6">
            <button className={'btn-chat'} onClick={ showOptions }> Opciones </button>
            {this.state.showOptions ?
              <div className={'options'}>
                <h4>CHAT OPTIONS</h4>
                <hr />
                <div className={'checkbox'}>
                  <input type="checkbox" checked={this.state.showDate} onChange={ showDate } />
                  <label>Mostrar Fecha</label>
                </div>
                <div className={'checkbox'}>
                  <input type="checkbox" checked={this.state.showTime} onChange={ showTime } />
                  <label>Mostrar Hora</label>
                </div>
              </div>
            : ''}
          </div>
          <div className="column-6">
            <button className={'btn-chat pull-right'} onClick={ this.publishMessage }> Enviar </button>
          </div>
        </div>
        { this.renderForm() }
      </div>
    );
  }
  componentDidUpdate() {
    if( this.mustScroll && this.lastMessage) {
      this.lastMessage.scrollIntoView();
      this.mustScroll = false;
    }
    if( this.mustFocus) {
      this.mustFocus = false;
      switch (this.state.renderForm) {
        case 'login': ReactDOM.findDOMNode(this.inputs.mail).focus(); break;
        case 'register': ReactDOM.findDOMNode(this.inputs.name).focus(); break;
        case 'userName': ReactDOM.findDOMNode(this.userNameField).focus(); break;
        case 'changePassword': ReactDOM.findDOMNode(this.inputs.password).focus(); break;
        default: ReactDOM.findDOMNode(this.inputField).focus();
      }
    }
  }
  componentWillUnmount() {
    if( this.refreshInterval) {
      clearInterval( this.refreshInterval);
    }
  }
}

ChatSidebar.defaultProps = defaultProps;
ChatSidebar.displayName = displayName;
ChatSidebar.propTypes = propTypes;
export default ChatSidebar;



// WEBPACK FOOTER //
// ./src/chat-sidebar/chat-sidebar.js